/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/select" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdSelect } from "./constants";
import type { LandingPagesSelectResult, LandingPagesSelectParams } from "./types";
import { isEngagementLandingPagesAppGroupIdSelectResult } from "./validators";

export const getEngagementLandingPagesAppGroupIdSelect = reactQueryFetcherAdapter(
  engagementLandingPagesAppGroupIdSelect,
  (signal: AbortSignal, params: LandingPagesSelectParams): Promise<LandingPagesSelectResult> => {
    return fetch(
      `/engagement/landing_pages/${params.appGroupId}/select`,
      "GET",
      { query: params.query ?? "", limit: params.limit ?? 0, has_survey: params.hasSurvey ?? undefined },
      { signal }
    );
  },
  isEngagementLandingPagesAppGroupIdSelectResult
);
